export default __webpack_public_path__ + "static/media/24.77fa46d1.jpg";